// Payments articles for the Help Center.

const payments = {
  slug: 'payments',
  label: 'Payments',
  icon: 'PiCurrencyDollar',
  description: 'Paying for something, getting paid, fees, and refunds.',
  articles: [
    {
      slug: 'adding-a-payment-method',
      title: 'Adding a payment method',
      summary: 'Save a card once, and use it for every order or job you fund.',
      body: [
        {
          type: 'p',
          text: 'Before you can pay for an order or fund a contract, you need a card on file. Go to Settings, then Paying, and add a card. You are only charged when you place an order or fund a contract, never for saving a card on its own.',
        },
        {
          type: 'p',
          text: 'You can update your card at any time from the same page. A new card becomes the default for future payments.',
        },
      ],
    },
    {
      slug: 'how-fees-work',
      title: 'How fees work',
      summary: 'Buyers pay a small fee on top, sellers have a small fee taken from payouts.',
      body: [
        {
          type: 'p',
          text: 'As a buyer, a service fee of ten percent is added on top of the price you see, shown clearly before you pay. As a seller, a five percent fee is taken out of your payout when an order completes. These fees cover the cost of running the site, including secure payments and escrow.',
        },
        {
          type: 'p',
          text: 'Shipping on physical items works differently. It is never charged a fee in either direction. Whatever shipping amount the seller sets is paid by the buyer and received in full by the seller.',
        },
      ],
    },
    {
      slug: 'getting-paid-as-a-freelancer',
      title: 'Getting paid as a freelancer',
      summary: 'Connect a payout account once, and payments arrive automatically.',
      body: [
        {
          type: 'p',
          text: 'To receive payments, go to Settings, then Getting Paid, and connect a payout account. This is handled through Stripe, which will ask for your bank details and some basic identity information, as any payment provider does.',
        },
        {
          type: 'p',
          text: 'Once connected, payouts happen automatically. There is nothing to request or withdraw yourself. When an order or contract completes and funds are released to you, they move to your connected account and pay out to your bank on Stripe\'s own schedule.',
        },
      ],
    },
    {
      slug: 'tax-information',
      title: 'Your tax information',
      summary: 'Stripe collects and verifies your tax info as part of getting paid.',
      body: [
        {
          type: 'p',
          text: 'When you connect a payout account in Settings, under Getting Paid, Stripe collects your identity and taxpayer information as part of that same setup. UniFreelancer never sees or stores that information directly. Stripe handles it, the same way it does for other marketplaces.',
        },
        {
          type: 'p',
          text: 'Your tax status shows on the Getting Paid page as one of three states: not started, action needed, or confirmed. Action needed means Stripe still wants something from you, usually a missing form or a detail it could not verify. Click through and Stripe will tell you exactly what is left.',
        },
        {
          type: 'note',
          text: 'If you earn $600 or more in a calendar year as a US freelancer, Stripe automatically prepares your 1099-NEC. It shows up on your Payouts page. There is nothing to request or fill out yourself.',
        },
      ],
    },
    {
      slug: 'understanding-your-earnings-page',
      title: 'Understanding your earnings page',
      summary: 'A breakdown of what is available, what is still clearing, and what you have earned overall.',
      body: [
        {
          type: 'p',
          text: 'Once your payout account is connected, Settings shows a breakdown of your money. Balance available is what Stripe currently shows as ready to pay out. Clearing with Stripe is money that has already been sent to your account but has not finished Stripe\'s own clearing process yet.',
        },
        {
          type: 'p',
          text: 'Held for active orders is different from both of those. It is money from orders that are still in progress and has not been released to you at all yet, because the buyer has not approved the work. Earnings to date is your lifetime total since joining, and if you have also bought things on the platform, expenses to date shows what you have spent as a buyer.',
        },
      ],
    },
    {
      slug: 'refunds-and-cancellations',
      title: 'Refunds and cancellations',
      summary: 'Cancelling an active order or contract refunds any held funds in full.',
      body: [
        {
          type: 'p',
          text: 'If a service agreement or contract has not been fully signed yet, cancelling it does not involve any money, since nothing has been charged. Once an order or fixed price contract is active and funded, either side can still cancel it. If you had paid, you are refunded the full amount.',
        },
        {
          type: 'p',
          text: 'Hourly contracts work a little differently, since you only ever pay for invoices you have already approved. Cancelling one stops future hours from being billed.',
        },
      ],
    },
  ],
};

export default payments;
